import CollegeHome from './CollegeHome';

export default CollegeHome;
